import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSwap = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M14.9696 3.46967C14.6767 3.76256 14.6767 4.23744 14.9696 4.53033L17.1892 6.74998L7.00001 6.74989C4.92893 6.74989 3.25 8.42883 3.25 10.4999C3.25 10.9141 3.58579 11.2499 4 11.2499C4.41422 11.2499 4.75 10.9141 4.75 10.4999C4.75 9.25725 5.75736 8.2499 7 8.24989L17.1893 8.24998L14.9696 10.4697C14.6767 10.7626 14.6767 11.2374 14.9696 11.5303C15.2625 11.8232 15.7373 11.8232 16.0302 11.5303L19.5302 8.03033C19.6709 7.88968 19.7499 7.69891 19.7499 7.5C19.7499 7.30109 19.6709 7.11032 19.5302 6.96967L16.0302 3.46967C15.7373 3.17678 15.2625 3.17678 14.9696 3.46967ZM9.53024 12.4697C9.23735 12.1768 8.76247 12.1768 8.46958 12.4697L4.96967 15.9696C4.67678 16.2625 4.67677 16.7373 4.96966 17.0302L8.46956 20.5303C8.76245 20.8232 9.23732 20.8232 9.53022 20.5303C9.82313 20.2375 9.82314 19.7626 9.53025 19.4697L7.31059 17.2499H17C19.0711 17.2499 20.75 15.571 20.75 13.4999C20.75 13.0857 20.4142 12.7499 20 12.7499C19.5858 12.7499 19.25 13.0857 19.25 13.4999C19.25 14.7425 18.2426 15.7499 17 15.7499H7.31067L9.53024 13.5303C9.82313 13.2374 9.82313 12.7626 9.53024 12.4697Z",
		fill: "currentcolor"
	})]
});
export default SvgSwap;
